import React, { useContext, useEffect, useState } from 'react'
import ButtonBlackReturn from '../Buttons/ButtonBlackReturn'
import AccessAreaContext from '../../context/AccessAreaContext/AccessAreaContext'
import ItemSelectableSimple from '../ItemSelectable/ItemSelectableSimple'
import { getTenantInfoByKey } from '../../helpers/helpers'
import { t } from 'i18next'
import useWindowSize from '../../customHooks/useWindowSize'
import AccessContext from '../../context/AccessContext/AccessContext'

const SelectArea = () => {
  const { windowWidth } = useWindowSize();

  const { accessState, setStep } = useContext(AccessContext);
  const { accessWithCar, type, accessWithEquipmentOrTools, } = accessState;

  const { accessAreaState, setAccessArea, getFreeAccessInAreas } = useContext(AccessAreaContext);
  const { accessAreas, /* isFetching, error, message, */ freeAccess } = accessAreaState;

  const [searchText, setSearchText] = useState('');

  const areaExist = accessAreas.length > 0;

  const freeAccessArea = {
    area_id: "",
    code: "",
    description: t('FREE_ACCESS_AREA')
  }

  const isVisit = 'ACCESS_VISIT' === type

  const accessAreasSearcheable = accessAreas.filter(accessArea => (accessArea.description.toLowerCase().includes(searchText) || accessArea.code.toLowerCase().includes(searchText)))

  const handleNextStep = (accessArea) => {
    setAccessArea(accessArea);
    const havePersonsToVisit = getTenantInfoByKey('has_people_to_visit');

    if (havePersonsToVisit) {
      setStep('SELECT_PERSON_TO_VISIT')
      return
    }

    setStep('DETAIL');
    return
  };

  const handleReturnStep = () => {

    if (accessWithEquipmentOrTools) {
      setStep('SELECT_EQUIPMENT_OR_TOOLS');
      return
    }

    if (accessWithCar) {
      const prevStep = isVisit ? 'VISIT_VEHICLE_FORM' : 'VEHICLES_SELECTABLE';
      setStep(prevStep);
      return
    }

    setStep('ACCESS_WITH');
    return
  };

  useEffect(() => {
    getFreeAccessInAreas();
    // eslint-disable-next-line
  }, [])

  return (
    <div className='d-flex flex-column justify-content-between h-100'>

      <div>
        <div>
          <h5 className='d-sm-block d-none fw-bold mb-4'>{`${t('SELECT')} ${getTenantInfoByKey('area_name')}`}</h5>
          <input
            type="text"
            className="form-control"
            placeholder={t('SEARCH')}
            name='search_text'
            value={searchText}
            // onKeyPress={search}
            onChange={(e) => setSearchText(e.target.value)}
          />
        </div>

        <div
          className='d-flex flex-column gap-2 no-show-scroll mt-3'
          style={{ maxHeight: windowWidth <= 576 ? '430px' : '380px', overflowX: 'auto' }}
        >
          {((!freeAccess) || (!areaExist)) && (
            <ItemSelectableSimple
              onClick={() => handleNextStep(freeAccessArea)}
            >
              {t('FREE_ACCESS_AREA')}
            </ItemSelectableSimple>
          )}

          {accessAreasSearcheable.map((accessArea, idx) =>
            <ItemSelectableSimple
              key={idx}
              onClick={() => handleNextStep(accessArea)}
            >
              {accessArea.code} - {accessArea.description}
            </ItemSelectableSimple>
          )}
        </div>


      </div>

      <div className='d-flex justify-content-between align-items-center mt-4 mb-4'>
        <div className="w-75">
          <ButtonBlackReturn
            title={t('GET_BACK')}
            onClick={handleReturnStep}
          />
        </div>
      </div>

    </div>
  )
}

export default SelectArea